import WrapperBlock from "@container/WrapperBlock";
import type { TRouteWithoutRedirect } from "@sphtech/web2-core/ssr";
import { CustomContext, useRouteContext } from "@sphtech/web2-core/ssr";
import { ResponseType } from "@sphtech/web2-core/ssr";
import MainBlock from "@src/app/components/Container/MainBlock";
import MainContainer from "@src/app/components/Container/MainContainer";
import SideBlock from "@src/app/components/Container/SideBlock";
import { OSResponse, PartialCueArticle } from "@typings/Opensearch";

import HomeMetaData from "./HomeMetaData";

export default function HomePage() {
  const routeContext: CustomContext<
    TRouteWithoutRedirect<OSResponse<PartialCueArticle>, string>
  > = useRouteContext();
  const dataLoaderResponse = routeContext.context;
  if (dataLoaderResponse.type === ResponseType.CLIENT_ERROR) {
    throw new Error("Client Error");
  } else if (dataLoaderResponse.type === ResponseType.SERVER_ERROR) {
    throw new Error("Server Error");
  }

  const { metaTags } = HomeMetaData();

  const sectionName = "/";
  return (
    <MainContainer metaTagsProps={metaTags} sectionName={sectionName}>
      <WrapperBlock className="flex flex-col lg:flex-row justify-between">
        <MainBlock showBreadcrumbs={false} showTitle={false}>
          <h1>Home Page</h1>
        </MainBlock>
        <SideBlock />
      </WrapperBlock>
    </MainContainer>
  );
}
